import type React from "react";
import { cn } from "src/shadcn/lib/utils";

import {
  Pagination as ShadcnPagination,
  PaginationContent as ShadcnPaginationContent,
  PaginationEllipsis as ShadcnPaginationEllipsis,
  PaginationItem as ShadcnPaginationItem,
  PaginationLink as ShadcnPaginationLink,
  PaginationNext as ShadcnPaginationNext,
  PaginationPrevious as ShadcnPaginationPrevious,
} from "src/shadcn/components/pagination";

const Pagination = (props: React.ComponentProps<typeof ShadcnPagination>) => (
  <ShadcnPagination {...props} />
);

const PaginationContent = (
  props: React.ComponentProps<typeof ShadcnPaginationContent>
) => <ShadcnPaginationContent {...props} />;

const PaginationEllipsis = (
  props: React.ComponentProps<typeof ShadcnPaginationEllipsis>
) => <ShadcnPaginationEllipsis {...props} />;

const PaginationItem = (
  props: React.ComponentProps<typeof ShadcnPaginationItem>
) => <ShadcnPaginationItem {...props} />;

const PaginationLink = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnPaginationLink>) => (
  <ShadcnPaginationLink
    className={cn("cursor-pointer aria-disabled:cursor-not-allowed", className)}
    {...props}
  />
);

const PaginationNext = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnPaginationNext>) => (
  <ShadcnPaginationNext
    className={cn("cursor-pointer aria-disabled:cursor-not-allowed", className)}
    {...props}
  />
);

const PaginationPrevious = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnPaginationPrevious>) => (
  <ShadcnPaginationPrevious
    className={cn("cursor-pointer aria-disabled:cursor-not-allowed", className)}
    {...props}
  />
);

export {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
};
